const USER_DATA = "__user";

export { USER_DATA };
